import ApiService from '@/services/core/api.service'

const CropHerbicideService = {
  async get (query) {
    return ApiService.get(`admin/crop-herbicides?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/crop-herbicides', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/crop-herbicides/${payload.id}`, payload)
  }
}

export default CropHerbicideService
